// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-CBc3","colBig":"styles_colBig__3rnDh","colSmall":"styles_colSmall__1Cw54","shopifyNameWrapper":"styles_shopifyNameWrapper__1VIjT"};